<template>
    <div
        class="flex w-full gap-4 overflow-scroll lg:justify-between lg:overflow-auto"
    >
        <div
            v-for="(item, index) in MENU_LIST['slots']"
            :key="index"
            class="relative w-[120px] flex-none cursor-pointer transition-all ease-in-out hover:-translate-y-[3px]"
            @click="redirect(item)"
        >
            <img
                v-if="item?.isHot"
                class="absolute left-0 top-0 h-auto w-10"
                :src="`${staticUrl}/assets/icons/hot.png`"
                alt="hot icon"
            />
            <img
                v-if="item?.isNew"
                class="absolute left-0 top-0 h-auto w-10"
                :src="`${staticUrl}/assets/icons/new.png`"
                alt="new icon"
            />
            <img
                class="mx-auto aspect-100/120 rounded-[3px] max-md:shadow"
                :src="`/assets/img/menu/${item.name}.png`"
                :alt="item.name"
            />
        </div>
    </div>
</template>
<script setup>
import { MENU_LIST } from '@/constants/menu.js'
const staticUrl = useRuntimeConfig().public.staticUrl
// const MENU_LIST = ref([])
// const { execute, data } = useFetch('/api/fe/menu', {
//     immediate: false,
// })

// await execute()
// MENU_LIST.value = data.value.data

const redirect = (item) => {
    navigateTo(item.url)
}
</script>
